/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import './Pay.css';
import '../dashboard/Dashboard.css';
import Card from 'react-bootstrap/Card';
import InputGroup from 'react-bootstrap/InputGroup';
import DataTableTemplatingDemoFoorShip from "./DataTableTemplatingDemoFoorShip";
import DataTableTemplatingDemo from '../../components/orders/DataTableTemplatingDemo/DataTableTemplatingDemo';
import Sidebar from '../../components/sidebar/Sidebar2';
import Navbar from '../../components/navbar/Navbar2';
import Footer from '../../components/footer/Footer';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import axios from 'axios';
import { Row, Col, Input, Tabs, Popover } from "antd";

import {
    Package,
    PackageCheck,
    Clock,
    Truck,
    Warehouse,
    MapPin,
    Bike,
    AlertCircle,
    CheckCircle,
    RotateCcw,
    Plus,
    Search,
    Calendar,
    ListOrdered,
    CheckCircle2,
    XCircle,
} from "lucide-react";
import {
    collection,
    getDocs,
    orderBy,
    query,
    where,
    serverTimestamp
} from "firebase/firestore";
import { db } from "../../firebase";
import FilterButton from "./FilterButton";
import { Timestamp } from "firebase/firestore";
import { fetchOrders as fetchOrdersAction } from "../../redux/orders/orders";

function foorship() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const account = useSelector((state) => state.AccountReducer);
    const products = useSelector((state) => state.ProductsReducer);
    const orders = useSelector((state) => state.OrdersReducer);
    const [showSideBar, setShowSideBar] = useState(true);
    const [selectedFilterDate, setSelectedFilterDate] = useState("week");
    const current_timestamp = Timestamp.fromDate(new Date());
    const [filterFirebaseStart, setFilterFirebaseStart] = useState(current_timestamp);
    const isRTL = i18n.dir() === "rtl";
    const todayy = new Date();
    todayy.setHours(0, 0, 0, 0);
    const todayTimestamp = Timestamp.fromDate(todayy);
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    const oneWeekAgoTimestamp = Timestamp.fromDate(oneWeekAgo);
    const oneMonthAgo = new Date();
    oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
    const oneMonthAgoTimestamp = Timestamp.fromDate(oneMonthAgo);

    const [filterFirebase, setFilterFirebase] = useState(oneWeekAgoTimestamp);
    const [endDate, setEndDate] = useState("");
    const [selected, setSelected] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isPageSizeOpen, setIsPageSizeOpen] = useState(false);
    const [lgShow, setLgShow] = useState(false);

    const filteredOrders =
        selected.length > 0
            ? orders.filter(
                (order) =>
                    (order.DC === "3" || order.DC === "1" || order.DC === "8" || order.DC === "5" || order.DC === "4" || order.DC === "6" || order.DC === "2" || order.DC === "7" || order.DC === "13" || order.DC === "12" || order.DC === "11") &&
                    order.products.some((product) => selected.includes(product.name))
            )
            : orders.filter(order => (order.DC === "3" || order.DC === "1" || order.DC === "8" || order.DC === "5" || order.DC === "4" || order.DC === "6" || order.DC === "2" || order.DC === "7" || order.DC === "13" || order.DC === "12" || order.DC === "11"));

    const filterOptions = [
        {
            key: [
                "EN PREPARATION",
                "WAREHOUSE EN PREPARATION",
                "DROPSHIP EN PREPARATION",
                "FRET EN PREPARATION",
                "En Dispatche",
                4, // تم الإنشاء
                6, // قيد المعالجة
                "en_preparation",
                "en_preparation_stock",
                "En préparation",
                "not-ready",
                "A vérifier",
                "En Préparation"
            ],
            label: t("ship.in_preparation"),
            icon: (active) => <Package size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        },
        {
            key: [
                "PRÊT À EXPÉDIER",
                "WAREHOUSE PRET",
                "DROPSHIP PRET",
                "FRET PRET",
                "Prêt pour livreur",
                15, // جاهز للإرسال
                22, // تم التعيين
                "prete_a_expedier",
                "paiements_prets",
                "ready",
                "Prêt à expédier",
                "Prêt pour livreur",
                "payed"
            ],
            label: t("ship.ready_to_ship"),
            icon: (active) => <PackageCheck size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        },
        {
            key: [
                "EN ATTENTE",
                "PAS ENCORE RAMASSÉ",
                "PICKUP",
                5,  // طلب الالتقاط
                11, // قيد الانتظار
                53, // لم يتم الاستلام
                "en_ramassage",
                "Pas encore ramassé",
                "En attente",
                "receivable",
                "Pas encore expédié"
            ],
            label: t("ship.awaiting_pickup"),
            icon: (active) => <Clock size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        },
        {
            key: [
                "EXPEDIE",
                "Dispatché",
                "RETOUR VERS CENTRE",
                "AU CENTRE",
                8, // في انتظار النقل
                9, // في طريقه إلى الإرسال
                "vers_hub",
                "Expédié",
                "Ramassé",
                "Transfert"
            ],
            label: t("ship.to_hub"),
            icon: (active) => <Truck size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        },
        {
            key: [
                "CENTRE ( HUB )",
                "RETOURNEE AU CENTRE",
                "RETOUR A RETIRER",
                "SOCIETE PARTENAIRE",
                52, // تم الاستلام من المتجر
                "en_hub",
                "Centre",
                "Reçu à Wilaya"
            ],
            label: t("ship.at_hub"),
            icon: (active) => <Warehouse size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        },
        {
            key: [
                "VERS WILAYA ( SAC )",
                "TRANSFERT (SAC)",
                "RETOUR VERS VENDEUR (SAC)",
                "En localisation",
                31, // تم الإرسال
                "vers_wilaya",
                "Vers Wilaya",
                "En localisation"
            ],
            label: t("ship.to_wilaya"),
            icon: (active) => <MapPin size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        },
        {
            key: [
                "SORTIE EN LIVRAISON",
                "TENTATIVE ÉCHOUÉE 1",
                "TENTATIVE ÉCHOUÉE 2",
                "TENTATIVE ÉCHOUÉE 3",
                32, // تم التنبيه
                "en_livraison",
                "Sorti en livraison",
                "En attente du client"
            ],
            label: t("ship.in_delivery"),
            icon: (active) => <Bike size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        },
        {
            key: [
                "ÉCHEC DE LIVRAISON",
                "ALERT",
                "REPORTER (Date)",
                "REFUSÉ",
                "WAREHOUSE HORS STOCK",
                "Bloqué",
                12, // نفدت الكمية
                42, // مؤجل
                50, // ملغى
                "suspendu",
                "livre_non_encaisse",
                "encaisse_non_paye",
                "annule",
                "Bloqué",
                "En alerte",
                "Tentative échouée",
                "Echèc livraison",
                "Echange échoué",
                "Débloqué"
            ],
            label: t("ship.on_hold"),
            icon: (active) => <AlertCircle size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        },
        {
            key: [
                "LIVRÉ",
                "ECHANGE COLLECTÉ",
                41, // تم التسليم
                "paye_et_archive",
                "Livré"
            ],
            label: t("ship.delivered"),
            icon: (active) => <CheckCircle size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        },
        {
            key: [
                "RETOURNEE AU VENDEUR (SAC)",
                "WAREHOUSE RETOURNÉE",
                "WAREHOUSE DEMANDE ANNULATION",
                "WAREHOUSE ANNULÉE",
                "WAREHOUSE RETOURNÉE ENDOMAGÉ",
                "ECHANGE A RETIRER",
                "DROPSHIPS RETOURNEÉ",
                "DROPSHIPS RETOURNEÉ ENDOMMAGÉ",
                "DROPSHIPS DEMANDE ANNULATION",
                "DROPSHIPS ANNULÉE",
                "FRET DEMANDE ANNULATION",
                "FRET ANNULÉE",
                10, // في طريقه للإرجاع
                51, // جاهز للإرجاع
                "retour_chez_livreur",
                "retour_transit_entrepot",
                "retour_en_traitement",
                "retour_reçu",
                "retour_archive",
                "Retour vers centre",
                "Retourné au centre",
                "Retour transfert",
                "Retour groupé",
                "Retour à retirer",
                "Retour vers vendeur",
                "Retourné au vendeur"
            ],
            label: t("ship.returned"),
            icon: (active) => <RotateCcw size={20} color={active ? "#553c9a" : "#9e68ba"} />,
        }
    ];

    const handleTabChange = (activeKey) => {
        switch (activeKey) {
            case "1":
                setFilterFirebase(todayTimestamp);
                setSelectedFilterDate("day");
                break;
            case "2":
                setFilterFirebase(oneWeekAgoTimestamp);
                setSelectedFilterDate("week");
                break;
            case "3":
                setFilterFirebase(oneMonthAgoTimestamp);
                setSelectedFilterDate("month");
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (account) {
            const fetchOrders = async () => {
                try {
                    const snapShot = await getDocs(
                        query(
                            collection(db, "orders"),
                            where("user", "==", account?.user),
                            where("timeStamp", "<", filterFirebaseStart),
                            where("timeStamp", ">", filterFirebase)
                        )
                    );
                    let list = [];
                    snapShot.docs.forEach((doc) => {
                        list.push({ id: doc.id, ...doc.data() });
                    });

                    const processedOrders = list
                        .filter((order) => order.deleted !== 1)
                        .sort(function (a, b) {
                            return b.timeStamp.seconds - a.timeStamp.seconds;
                        })
                        .map((item, index) => ({
                            ...item,
                            index:
                                list.filter((order) => order.deleted !== 1).length -
                                index +
                                999,
                        }));

                    dispatch(fetchOrdersAction(processedOrders));
                } catch (error) {
                    console.log(error);
                }
            };

            fetchOrders();
        }
    }, [filterFirebase, filterFirebaseStart, account, dispatch]);

    const pageSizeOptions = [
        { value: 5, label: t("ship.five_orders") },
        { value: 10, label: t("ship.ten_orders") },
        { value: 25, label: t("ship.twenty_five_orders") },
        { value: 50, label: t("ship.fifty_orders") },
    ];

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        setSelectedFilterDate("custom");
        const targetDate = new Date(endDate);
        const currentDate = new Date();
        const timeDifference = targetDate.getTime() - currentDate.getTime();
        const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        const d = new Date();
        d.setDate(d.getDate() + parseInt(daysDifference));
        const dTimestamp = Timestamp.fromDate(d);
        setFilterFirebase(dTimestamp);
    };

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };

    useEffect(() => {
        function handleResize() {
            if (window.innerWidth <= 1080) {
                setShowSideBar(false);
            } else {
                setShowSideBar(true);
            }
        }

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const [pageSize, setPageSize] = useState(10);
    const [len, setLen] = useState(0);
    let [page, setPage] = useState(1);

    const content = (
        <div>
            <div className="d-flex">
                <div
                    className={`border p-2 ms-2 ${selectedFilterDate !== "month" &&
                        selectedFilterDate !== "week" &&
                        selectedFilterDate !== "day"
                        ? "bg-info"
                        : ""
                        }`}
                >
                    <input
                        type="date"
                        id="endDateInput"
                        name="endDateInput"
                        value={endDate}
                        onChange={handleEndDateChange}
                        required
                        className="border-0 bg-transparent focus:outline-none"
                    />
                </div>
                <button onClick={handleSearchSubmit}>
                    <img
                        src="https://cdn-icons-png.flaticon.com/128/1168/1168610.png"
                        className="icon w-10 h-10"
                    />
                </button>
            </div>
        </div>
    );

    const toggleProduct = (name) => {
        setSelected((prev) =>
            prev.includes(name)
                ? prev.filter((pname) => pname !== name)
                : [...prev, name]
        );
    };

    const handlePageSizeSelect = (value) => {
        setPageSize(value);
        setIsPageSizeOpen(false);
    };

    const [filter, setFilter] = useState('');
    const [filter2, setFilter2] = useState('');

    return (
        <div className='container-fluid dark:!bg-[#141414]' style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
            <div className="row">
                {showSideBar && (
                    <div style={{ width: "250px", flexShrink: 0, transition: "width 0.6s ease" }}>
                        <Sidebar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
                    </div>
                )}
                <div
                    className="px-3 w-full dark:!bg-[#141414]"
                    style={{ flex: 1, backgroundColor: "#fbf8fc" }}
                >
                    <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
                    <div className="m-3 p-0">
                        {/* Page Header */}
                        <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-purple-100 dark:!border-[#3c3a3d]">
                            <div className="flex flex-wrap items-center justify-between gap-3">
                                <div>
                                    <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                                        {t("ship.foorship_shipping")}
                                    </h2>
                                    <p className="text-gray-600 dark:text-gray-300 mb-0">
                                        {t("ship.track_all_orders")}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Date Filter Tabs */}
                        <div className="mx-3 mb-3 flex items-center justify-between">
                            <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-purple-100 overflow-hidden dark:!border-[#3c3a3d]">
                                <div className="flex">
                                    <button
                                        className={`px-6 py-3 text-sm font-medium transition-colors ${selectedFilterDate === "day"
                                            ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                                            : "text-gray-600 hover:bg-[#6e358c] dark:text-gray-300 "
                                            }`}
                                        onClick={() => handleTabChange("1")}
                                    >
                                        {t("ship.today")}
                                    </button>
                                    <button
                                        className={`px-6 py-3 text-sm font-medium transition-colors ${selectedFilterDate === "week"
                                            ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                                            : "text-gray-600 hover:bg-[#6e358c] dark:text-gray-300 "
                                            }`}
                                        onClick={() => handleTabChange("2")}
                                    >
                                        {t("ship.seven_days")}
                                    </button>
                                    <button
                                        className={`px-6 py-3 text-sm font-medium transition-colors ${selectedFilterDate === "month"
                                            ? "bg-purple-50 dark:bg-[#522868] dark:text-gray-300 text-[#9e68ba] border-b-2 border-[#9b59bf]"
                                            : "text-gray-600 hover:bg-[#6e358c] dark:text-gray-300 "
                                            }`}
                                        onClick={() => handleTabChange("3")}
                                    >
                                        {t("ship.month")}
                                    </button>
                                    <Popover placement="bottom" content={content} trigger="click">
                                        <img
                                            src="https://cdn-icons-png.flaticon.com/512/4799/4799625.png"
                                            alt={t("ui.calendarIcon")}
                                            className="w-8 h-8 cursor-pointer mx-2 mt-[8px]"
                                        />
                                    </Popover>
                                </div>
                            </div>
                        </div>

                        {/* Status Filter Cards */}
                        <div className="mx-3 mb-4 overflow-x-auto py-2 px-1">
                            <div className="flex md:grid md:grid-cols-4 lg:grid-cols-8 gap-3 min-w-max md:min-w-0">
                                <button
                                    onClick={() => setFilter2("")}
                                    className={`flex-shrink-0 flex items-center p-3 rounded-xl shadow-sm transition-all duration-200 ${filter2 === ""
                                        ? "bg-[#faf1ff] dark:bg-[#262526] border-[#9b59bf] border-2 shadow-md"
                                        : "bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow"
                                        }`}
                                >
                                    <div
                                        className={`w-8 h-8 rounded-lg ${filter2 === "" ? "bg-[#efd3ff] dark:bg-[#181919]" : "bg-[#faf1ff] dark:bg-[#181919]"
                                            } flex items-center justify-center mr-3`}
                                    >
                                        <ListOrdered
                                            size={18}
                                            className={`${filter2 === "" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                                                }`}
                                        />
                                    </div>
                                    <div className="text-left mx-2">
                                        <div
                                            className={`text-sm font-medium ${filter2 === "" ? "text-[#9e68ba]" : "text-gray-800 dark:!text-gray-300"
                                                }`}
                                        >
                                            {t("ship.all")}
                                        </div>
                                        <div
                                            className={`font-bold ${filter2 === "" ? "text-[#9e65bb]" : "text-[#9e68ba]"
                                                }`}
                                        >
                                            {
                                                filteredOrders.filter((order) => order)
                                                    .length
                                            }
                                        </div>
                                    </div>
                                </button>
                                {filterOptions.map((opt) => (
                                    <FilterButton
                                        key={opt.key}
                                        filterKey={opt.key}
                                        label={opt.label}
                                        filter2={filter2}
                                        setFilter2={setFilter2}
                                        orders={filteredOrders}
                                        icon={opt.icon(filter2 === opt.key)}
                                    />
                                ))}
                            </div>
                        </div>

                        {/* Search and Filter Bar */}
                        <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 mx-3 mb-4 border border-purple-100 dark:!border-[#3c3a3d]">
                            <div className="flex flex-wrap items-center justify-between gap-3">
                                <div className="relative flex-grow max-w-xl">
                                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                        <Search size={16} className="text-gray-400" />
                                    </div>
                                    <input
                                        type="text"
                                        className="bg-gray-50 border border-gray-200 dark:!border-[#3c3a3d] dark:!bg-[#181819] text-gray-900 text-sm rounded-lg block w-full pr-10 p-2.5 focus:outline-none focus:ring-2 focus:ring-purple-200"
                                        placeholder={t("ship.search_by_order_number_customer_name_phone")}
                                        value={filter}
                                        onChange={(e) => setFilter(e.target.value)}
                                    />
                                </div>

                                <div className="flex flex-row items-center gap-x-4">
                                    <div className="flex items-center gap-4">
                                        <div className="relative">
                                            {/* Main Trigger Button */}
                                            <div
                                                onClick={() => setIsOpen(!isOpen)}
                                                className="group relative bg-gray-50 dark:bg-[#181919] dark:!border-[#3c3a3d] border border-gray-200 hover:border-[#9b59bf] text-gray-900 text-sm rounded-lg p-2.5 cursor-pointer min-w-[180px] transition-all duration-200 hover:shadow-sm focus:ring-2 focus:ring-purple-200"
                                            >
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center gap-2">
                                                        {/* Product Icon */}
                                                        <div className="w-5 h-5 bg-[#faf1ff] rounded-md dark:bg-[#181919] flex items-center justify-center">
                                                            <svg
                                                                className="w-3 h-3 text-[#9b59bf]"
                                                                fill="currentColor"
                                                                viewBox="0 0 20 20"
                                                            >
                                                                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V4z" />
                                                            </svg>
                                                        </div>

                                                        {/* Text Content */}
                                                        <span className="font-medium text-gray-900 dark:text-gray-300">
                                                            {selected.length > 0
                                                                ? selected.length === 1
                                                                    ? t("ship.one_product")
                                                                    : t("ship.products", { count: selected.length })
                                                                : t("ship.select_products")}
                                                        </span>
                                                    </div>

                                                    {/* Arrow Icon with Animation */}
                                                    <div
                                                        className={`transform transition-transform duration-200 ${isOpen ? "rotate-180" : ""
                                                            }`}
                                                    >
                                                        <svg
                                                            className="w-4 h-4 text-gray-500"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth={2}
                                                                d="M19 9l-7 7-7-7"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>

                                                {/* Selected count badge */}
                                                {selected.length > 0 && (
                                                    <div className="absolute -top-1 -right-1 bg-[#9b59bf] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold shadow-sm">
                                                        {selected.length}
                                                    </div>
                                                )}
                                            </div>

                                            {/* Dropdown Menu */}
                                            <div className="relative">
                                                {isOpen && (
                                                    <>
                                                        {/* Backdrop for mobile */}
                                                        <div
                                                            className="fixed inset-0  bg-opacity-5 z-40 md:hidden"
                                                            onClick={() => setIsOpen(false)}
                                                        />

                                                        {/* Dropdown Container */}
                                                        <div
                                                            className="absolute mt-1 bg-white dark:bg-[#181919] dark:text-gray-300 border border-gray-200 dark:!border-[#3c3a3d] rounded-lg shadow-lg max-h-60 overflow-hidden w-full animate-in slide-in-from-top-1 duration-150"
                                                            style={{
                                                                zIndex: 100000,
                                                            }}
                                                        >
                                                            {/* Header */}
                                                            <div className="bg-[#faf1ff] dark:bg-[#181919] px-4 py-2.5 border-b border-purple-100 dark:!border-[#3c3a3d]">
                                                                <div className="flex items-center justify-between">
                                                                    <span className="font-medium text-gray-800 dark:text-gray-300 text-sm">
                                                                        {t("orders.available_products")}
                                                                    </span>
                                                                    {selected.length > 0 && (
                                                                        <button
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setSelected([]);
                                                                            }}
                                                                            className="text-xs text-[#9b59bf] hover:text-[#814a9f] font-medium transition-colors"
                                                                        >
                                                                            {t("orders.clear_all")}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* Products List */}
                                                            <div
                                                                className="max-h-48 overflow-y-auto"
                                                                style={{
                                                                    scrollbarWidth: "thin",
                                                                    scrollbarColor: "#d8b4fe #f5f5f5",
                                                                    zIndex: 100000,
                                                                }}
                                                            >
                                                                {products.map((product, index) => {
                                                                    const isSelected = selected.includes(
                                                                        product.name
                                                                    );
                                                                    return (
                                                                        <label
                                                                            key={product.id}
                                                                            className={`group dark:bg-[#181919] flex items-center gap-2 px-4 py-2.5 hover:bg-[#faf1ff] cursor-pointer transition-colors duration-150 ${isSelected
                                                                                ? "bg-[#faf1ff] border-r-2 border-[#9b59bf]"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {/* Custom Checkbox */}
                                                                            <div className="relative flex-shrink-0">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={isSelected}
                                                                                    onChange={() =>
                                                                                        toggleProduct(product.name)
                                                                                    }
                                                                                    className="sr-only"
                                                                                />
                                                                                <div
                                                                                    className={`w-4 h-4 rounded border transition-all duration-200 flex items-center justify-center ${isSelected
                                                                                        ? "bg-[#9b59bf] dark:!bg-[#181919] border-[#9b59bf]"
                                                                                        : "border-gray-300 hover:border-[#9b59bf]"
                                                                                        }`}
                                                                                >
                                                                                    {isSelected && (
                                                                                        <svg
                                                                                            className="w-3 h-3 text-white"
                                                                                            fill="currentColor"
                                                                                            viewBox="0 0 20 20"
                                                                                        >
                                                                                            <path
                                                                                                fillRule="evenodd"
                                                                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                                                                clipRule="evenodd"
                                                                                            />
                                                                                        </svg>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            {/* Product Name */}
                                                                            <span
                                                                                className={`text-sm transition-colors ${isSelected
                                                                                    ? "text-[#9b59bf] font-medium"
                                                                                    : "text-gray-800 dark:text-gray-300 group-hover:text-[#9b59bf]"
                                                                                    }`}
                                                                            >
                                                                                {product.name}
                                                                            </span>

                                                                            {/* Selection Indicator */}
                                                                            {isSelected && (
                                                                                <div className="w-1.5 h-1.5 bg-[#9b59bf] rounded-full ml-auto" />
                                                                            )}
                                                                        </label>
                                                                    );
                                                                })}
                                                            </div>

                                                            {/* Empty State */}
                                                            {products.length === 0 && (
                                                                <div className="px-4 py-8 text-center text-gray-500">
                                                                    <div className="w-8 h-8 mx-auto mb-2 text-gray-300">
                                                                        <svg fill="currentColor" viewBox="0 0 20 20">
                                                                            <path d="M10 2L3 7v11a1 1 0 001 1h12a1 1 0 001-1V7l-7-5zM10 12a2 2 0 100-4 2 2 0 000 4z" />
                                                                        </svg>
                                                                    </div>
                                                                    <span className="text-sm">
                                                                        {t("orders.no_products_available")}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        {/* Page Size Selector */}
                                        <div className="relative">
                                            {/* Main Trigger Button */}
                                            <div
                                                onClick={() => setIsPageSizeOpen(!isPageSizeOpen)}
                                                className="group relative bg-gray-50 dark:bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] hover:border-[#9b59bf] text-gray-900 text-sm rounded-lg p-2.5 cursor-pointer min-w-[140px] transition-all duration-200 hover:shadow-sm focus:ring-2 focus:ring-purple-200"
                                            >
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center gap-2">
                                                        {/* Page Size Icon */}
                                                        <div className="w-5 h-5 bg-[#faf1ff] dark:bg-[#181919] rounded-md flex items-center justify-center">
                                                            <svg
                                                                className="w-3 h-3 text-[#9b59bf]"
                                                                fill="currentColor"
                                                                viewBox="0 0 20 20"
                                                            >
                                                                <path d="M3 4a1 1 0 000 2h14a1 1 0 100-2H3zM3 10a1 1 0 000 2h14a1 1 0 100-2H3zM3 16a1 1 0 100 2h14a1 1 0 100-2H3z" />
                                                            </svg>
                                                        </div>

                                                        {/* Current Selection */}
                                                        <span className="font-medium text-gray-900 dark:text-gray-300">
                                                            {pageSizeOptions.find(
                                                                (option) => option.value == pageSize
                                                            )?.label || t("orders.ten_orders")}
                                                        </span>
                                                    </div>

                                                    {/* Arrow Icon with Animation */}
                                                    <div
                                                        className={`transform transition-transform duration-200 ${isPageSizeOpen ? "rotate-180" : ""
                                                            }`}
                                                    >
                                                        <svg
                                                            className="w-4 h-4 text-gray-500"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth={2}
                                                                d="M19 9l-7 7-7-7"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Dropdown Menu */}
                                            <div className="relative">
                                                {isPageSizeOpen && (
                                                    <>
                                                        {/* Backdrop for mobile */}
                                                        <div
                                                            className="fixed inset-0  bg-opacity-5 z-40 md:hidden"
                                                            onClick={() => setIsPageSizeOpen(false)}
                                                        />

                                                        {/* Dropdown Container */}
                                                        <div
                                                            className="absolute mt-1 bg-white dark:!bg-[#181919] border border-gray-200 dark:!border-[#3c3a3d] rounded-lg shadow-lg overflow-hidden w-full animate-in slide-in-from-top-1 duration-150"
                                                            style={{ zIndex: 100000 }}
                                                        >
                                                            {/* Header */}
                                                            <div className="bg-[#faf1ff] dark:bg-[#141414] px-4 py-2.5 border-b border-purple-100 dark:!border-[#3c3a3d]">
                                                                <span className="font-medium text-gray-800 dark:text-gray-300 text-sm">
                                                                    {t("orders.orders_per_page")}
                                                                </span>
                                                            </div>

                                                            {/* Options List */}
                                                            <div className="max-h-48 overflow-y-auto">
                                                                {pageSizeOptions.map((option) => {
                                                                    const isSelected = pageSize == option.value;
                                                                    return (
                                                                        <button
                                                                            key={option.value}
                                                                            onClick={() =>
                                                                                handlePageSizeSelect(option.value)
                                                                            }
                                                                            className={`w-full group flex items-center gap-2 px-4 py-2.5 hover:bg-[#faf1ff] cursor-pointer transition-colors duration-150 text-right ${isSelected
                                                                                ? "bg-[#faf1ff] dark:!bg-[#2a2b2b] border-r-2 border-[#9b59bf]"
                                                                                : ""
                                                                                }`}
                                                                        >
                                                                            {/* Selection Indicator */}
                                                                            <div className="relative flex-shrink-0">
                                                                                <div
                                                                                    className={`w-4 h-4 rounded-full border transition-all duration-200 flex items-center justify-center ${isSelected
                                                                                        ? "bg-[#9b59bf] border-[#9b59bf]"
                                                                                        : "border-gray-300 hover:border-[#9b59bf]"
                                                                                        }`}
                                                                                >
                                                                                    {isSelected && (
                                                                                        <div className="w-2 h-2 bg-white rounded-full" />
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            {/* Option Label */}
                                                                            <span
                                                                                className={`text-sm transition-colors ${isSelected
                                                                                    ? "text-[#9b59bf] font-medium"
                                                                                    : "text-gray-800 dark:text-gray-300 group-hover:text-[#9b59bf]"
                                                                                    }`}
                                                                            >
                                                                                {option.label}
                                                                            </span>
                                                                        </button>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Data Table */}
                        <div className="mx-3 bg-white rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d] p-0 mb-6 overflow-hidden">
                            {orders.length > 0 && (
                                <DataTableTemplatingDemoFoorShip
                                    setLgShow={setLgShow}
                                    pageSize={pageSize}
                                    filter={filter}
                                    orders={filteredOrders.filter((order) => {
                                        if (filter2.length === 0) {
                                            return true;
                                        } else {
                                            return filter2.includes(order?.CompanyDeleveryStatus);
                                        }
                                    })}
                                />
                            )}
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default foorship;